import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../core/constants/routes';

/**
 * Hook personnalisé pour gérer la navigation vers les détails d'une activité
 * @returns {Object} - Fonctions et états liés à la navigation vers les activités
 */
export const useActivityNavigation = () => {
  const navigate = useNavigate();

  // Fonction pour naviguer vers les détails d'une activité
  const goToActivityDetails = useCallback((postId) => {
    if (!postId) return;
    navigate(`${ROUTES.DASHBOARD}/activity/${postId}`);
  }, [navigate]);

  // Fonction pour retourner à la page précédente
  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return {
    goToActivityDetails,
    goBack
  };
}; 